import React, { Fragment, FunctionComponent } from 'react';
import { PageWrapper } from 'components/presentional';
import { usePages } from 'hooks';
import {
  CaseStudyItems,
  CompanyLogos,
  DescriptionColumns,
  Features,
  HeroImageDescription,
  HeroImageTop,
  Technologies,
  Bio,
  Testimonials,
  SeoDescription,
  Description,
} from 'components/containers';
import { WPSimplePage } from 'types/pages';
import { WPAcfSocialEngineeringTests } from 'types/acf';
import { useRouteTranslations } from 'utils';
import { CustomArticleSlugTypes } from 'types/global';

interface OwnProps {}

type SocialEngineeringTestsPageProps = Omit<JSX.IntrinsicElements['article'], 'children'> & OwnProps;

const SocialEngineeringTestsPage: FunctionComponent<SocialEngineeringTestsPageProps> = props => {
  const SOCIAL_ENGINEERING_TESTS_PAGE_SLUG_TYPE: CustomArticleSlugTypes = 'social_engineering_tests';
  const { translateSlug } = useRouteTranslations();
  const { data: page, loading } = usePages<WPSimplePage<WPAcfSocialEngineeringTests>>({ slug: translateSlug(SOCIAL_ENGINEERING_TESTS_PAGE_SLUG_TYPE) });

  const [customPage] = page || [];

  if (!customPage) {
    return null;
  }

  const {
    acf: {
      heroImageTop,
      heroImageDescriptions,
      testimonials,
      bio,
      technologies,
      descriptionColumns,
      companyLogos,
      features,
      seoDescription,
      useCases,
      descriptionBlock,
    },
  } = customPage;

  return (
    <PageWrapper title={customPage?.yoast_title} meta={customPage?.yoast_meta} loading={loading} name={SOCIAL_ENGINEERING_TESTS_PAGE_SLUG_TYPE}>
      {page && (
        <Fragment>
          {heroImageTop && <HeroImageTop data={heroImageTop} />}
          {descriptionBlock && <Description data={descriptionBlock} />}
          {heroImageDescriptions && <HeroImageDescription data={heroImageDescriptions} />}
          {companyLogos && <CompanyLogos simple={true} data={companyLogos} />}
          {features && <Features theme="white" data={features} />}
          {bio && <Bio data={bio} />}
          {descriptionColumns && <DescriptionColumns data={descriptionColumns} />}
          {technologies && <Technologies data={technologies} />}
          {useCases && <CaseStudyItems data={useCases} showMore={true} loadMore={false} />}
          {testimonials && <Testimonials data={testimonials} />}
          {seoDescription && false && <SeoDescription data={seoDescription} />}
        </Fragment>
      )}
    </PageWrapper>
  );
};

export default SocialEngineeringTestsPage;
